export default "<p>agropolos-file-upload works!</p>\r\n"